import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit, OnInit
} from '@angular/core';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {MediaMatcher} from '@angular/cdk/layout';
import {Menu, MenuItems} from '../../../shared/menu-items/menu-items';
import {AuthService} from '../../../authentication/auth.service';
import {Subscription} from 'rxjs';
import PerfectScrollbar from 'perfect-scrollbar';
import {User} from '../../../authentication/User/user';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent implements OnDestroy, OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;

  readonly public;
  public userName: string;
  private _mobileQueryListener: () => void;
  subscription: Subscription;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private authService: AuthService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  public logOut(): void {
    this.authService.doLogout();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    const self = this;
    this.subscription = this.authService.userInfo$.subscribe(
      info => {
        self.userName = info;
      });
    self.userName = this.authService.getUserName();
  }

  getRoleSpecificMenuItems(): Menu[] {
    // const user: User = new User(JSON.parse(localStorage.getItem('User')));
    // return this.menuItems.getMenuitem().filter(item => {
    //   if (item.managerVisible) {
    //     return true;
    //   } else {
    //     return item.managerVisible === user.isManager();
    //   }
    // });
    return this.menuItems.getMenuitem();
  }
}
